export const ServerAuthenticationMutation = `
  mutation Authentication($email: String, $password: String, $subdomain: String, $csid: String) {
    authenticate(
      email: $email,
      password: $password,
      subdomain: $subdomain,
      csid: $csid
    ) {
      state
      authState
      otpIdentifier
      errors
      user {
        id
        email
        first_name
        last_name
        token
      }
    }
  }
`

export const ServerOtpAuthenticationMutation = `
  mutation OtpAuthentication($code: String, $otpIdentifier: String, $csid: String) {
    verifyOtp(
      code: $code,
      otpIdentifier: $otpIdentifier,
      csid: $csid
    ) {
      state
      authState
      otpIdentifier
      errors
      user {
        id
        email
        first_name
        last_name
        token
      }
    }
  }
`
